import React from 'react';
import CompanyTable from './Component/Company/CompanyTable';

const CompanyManagement = () => {
    return (
        <div>
            <CompanyTable/>
        </div>
    )
}

export default CompanyManagement;